// API 配置
export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 10000,
}

// 獲取完整的 API URL
export const getApiUrl = (endpoint: string): string => {
  // 如果 endpoint 已經是完整 URL，直接返回
  if (endpoint.startsWith('http')) {
    return endpoint
  }
  
  // 移除開頭的 / 避免重複
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
  
  // 如果 baseURL 已經包含 /api，不要重複添加
  if (API_CONFIG.baseURL.endsWith('/api') && cleanEndpoint.startsWith('api/')) {
    return `${API_CONFIG.baseURL}/${cleanEndpoint.slice(4)}`
  }
  
  return `${API_CONFIG.baseURL}/${cleanEndpoint}`
}

// 創建標準的 fetch 配置
export const createFetchConfig = (options: RequestInit = {}): RequestInit => {
  const token = localStorage.getItem('auth_token')

  return {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers,
    },
  }
}

// 統一的 API 調用函數
export const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  const url = getApiUrl(endpoint)
  const config = createFetchConfig(options)
  
  try {
    const response = await fetch(url, config)
    
    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`API Error (${response.status}): ${errorText || response.statusText}`)
    }
    
    return response.json()
  } catch (error) {
    console.error('API Call Error:', { url, error })
    throw error
  }
}

export default API_CONFIG